import type {
	ConversationChannel,
	RovoConversationSpace,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { setConversationData } from './setConversationData';
import type { ChatStoreAction, ChatStoreContainerProps } from './types';

type Dispatch = Parameters<ChatStoreAction>[0]['dispatch'];

/**
 * Applies the singular-conversation space enrichment without making the chat
 * store depend directly on the Spaces store.
 */
export const hydrateConversationSpaces = ({
	conversationId,
	metadata,
	dispatch,
	onConversationSpacesHydrated,
}: {
	conversationId: string;
	metadata: ConversationChannel;
	dispatch: Dispatch;
	onConversationSpacesHydrated?: ChatStoreContainerProps['onConversationSpacesHydrated'];
}): void => {
	const spaces: RovoConversationSpace[] = metadata.spaces ?? [];
	const associatedSpace = spaces.at(0);
	if (!associatedSpace) {
		return;
	}

	dispatch(
		setConversationData({
			conversationId,
			data: { rovoSpaceId: associatedSpace.id },
		}),
	);
	onConversationSpacesHydrated?.(conversationId, spaces);
};
